<script>
    import { Loading, Table } from "attractions";
    import { onMount } from "svelte";
    import Product from "../../Models/Product";
    import { LATEST_ADDED_PRODUCT, LATEST_EDITED_PRODUCT } from "../../Stores/Product";
    import EditProductInput from "./EditProductInput.svelte";

    let APIResponse;
    let headers = [
        { text: 'Nazwa', value: 'name' },
        { text: 'Cena', value: 'price' },
        { text: 'Rabat', value: 'discount' }
    ];
    let unremovedProducts = [];
    let items = [];

    async function getProducts() {
        APIResponse = null;
        APIResponse = await Product.get();
        if (APIResponse) {
            unremovedProducts = [];
            APIResponse.forEach(product => {
                const { _id, discount, name, price, removed } = product;
                if (!removed) {
                    unremovedProducts.push({
                        _id,
                        discount,
                        name,
                        price,
                        removed
                    });
                }
            })
            items = unremovedProducts;
            items.sort((a, b) => a.name.localeCompare(b.name));
        }
    }

    LATEST_ADDED_PRODUCT.subscribe(getProducts);
    LATEST_EDITED_PRODUCT.subscribe(getProducts);

    onMount(getProducts);

</script>

{#if (items && items.length) || APIResponse}
    {#if items && items.length}
        <Table {headers} {items}>
            <div let:header let:item slot="item">
                <EditProductInput _id={item['_id']} field={{ name: header['value'], value: item[header['value']] }} />
            </div>
        </Table>
    {/if}
{:else}
    <section class="productsLoader">
        <Loading />
    </section>
{/if}

<style>
    .productsLoader {
        display: flex;
        justify-content: center;
        min-height: 100px;
    }
</style>